$(document).ready(function() {

    $('.collapsible__close').click(function(event) {
        event.preventDefault();
        $(this).closest('.product-full-width-section').find('.product-section-title').trigger('click');
    });
});
